import React, {useEffect, useState} from 'react';
import {Box, Button, HStack, Spinner, Text} from '@chakra-ui/react';
import axios from "axios";
import {motion} from 'framer-motion';

const MotionedBox = motion(Box);


const News = () => {
    const [startIndex, setStartIndex] = useState(0)
    // const scrollToTop = () => {
    //     window.scrollTo({
    //         top: 0,
    //         behavior: "smooth"
    //     });
    // };
    const [insightsNewsPageData, setInsightsNewsPageData] = useState(undefined)

    useEffect(() => {
        const fetchNewsPageData = async () => {
            const insightsNewsPageData = await axios.get(`/wp-admin/admin-ajax.php?action=get_news&news_start=${startIndex}`).then(resp => {
                return resp.data;
            });
            setInsightsNewsPageData(insightsNewsPageData)
        }
        fetchNewsPageData()
    }, [startIndex])

    if (!insightsNewsPageData) {
        return (
            <Box my={20} width="100%" textAlign="center">
                <Spinner color='blue.600' size='xl'/>
            </Box>
        )
    }

    return (
        <>
            <Box
                borderLeft={{base: 'none', md: '1px solid #A1B6E5'}}
                pl={{md: '21px', base: '0'}}
            >
                <Text
                    display={{base: 'flex', md: 'none'}}
                    mb={'41px'}
                    fontSize={'18px'}
                    lineHeight={'18px'}
                >
                    News
                </Text>
                {insightsNewsPageData.map((item) => (
                    <NewsItem key={item.ID} {...item} />
                ))}
            </Box>
            <HStack spacing='24px'>
                {startIndex > 0 &&
                    <Button
                        size={'sm'}
                        py={'18px'}
                        minW={'100px'}
                        textColor={'black'}
                        fontWeight={'semibold'}
                        fontSize={'xs'}
                        variant={'brand'}
                        borderRadius={'full'}
                        colorScheme={'brand'}
                        borderColor={'rgba(11, 46, 251, 0.5)'}
                        onClick={() => {
                            // scrollToTop()
                            setStartIndex(startIndex - 5)
                        }}
                    >
                        Previous
                    </Button>
                }
                <Button
                    size={'sm'}
                    py={'18px'}
                    minW={'100px'}
                    textColor={'black'}
                    fontWeight={'semibold'}
                    fontSize={'xs'}
                    variant={'brand'}
                    borderRadius={'full'}
                    colorScheme={'brand'}
                    borderColor={'rgba(11, 46, 251, 0.5)'}
                    onClick={() => {
                        // scrollToTop()
                        setStartIndex(parseInt(startIndex.toString()) + 10)
                    }}
                >
                    Next
                </Button>
            </HStack>
        </>
    );
};

export default News;

const NewsItem = (props) => {
    const {ID, post_title, news_source, link_url} = props;
    return (
        <MotionedBox
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            transition={{
                delay: 0.3,
                default: {duration: 0.5},
            }}
        >
            <a itemID={ID} href={`${link_url}`} target={'_blank'} rel="noopener noreferrer">
                <Box mb={'50px'}>
                    <Text
                        fontWeight={500}
                        mb={'5px'}
                        color={'brand.700'}
                        fontSize={'16px'}
                        lineHeight={'32px'}
                    >
                        {news_source}
                    </Text>
                    <Text fontSize={'18px'} lineHeight={'21.6px'} noOfLines={2}>
                        {post_title}
                    </Text>
                </Box>
            </a>
        </MotionedBox>
    );
};
